export { FacilitiesV2Connected as FacilitiesV2 } from './container';
